import { useState } from "react";
import { X } from "lucide-react";

import { SearchPick } from "../library/Pickers";
import { humanise } from "./registerLogic";

export type StaffOption = { id: number; full_name: string; role: string };

/** Several staff from a long list: chips for those chosen, a search to add more. */
export function StaffPicker({ staff, value, onChange }: { staff: StaffOption[]; value: number[]; onChange: (next: number[]) => void }) {
  const [adding, setAdding] = useState("");
  const chosen = staff.filter((row) => value.includes(row.id));
  return (
    <div className="mt-1 space-y-2">
      {chosen.length > 0 && (
        <ul className="flex flex-wrap gap-1.5">
          {chosen.map((row) => (
            <li key={row.id} className="inline-flex items-center gap-1 rounded-full bg-primary-50 py-1 pl-2.5 pr-1 text-xs font-medium text-primary-800">
              {row.full_name}
              <button type="button" onClick={() => onChange(value.filter((id) => id !== row.id))} className="rounded-full p-0.5 hover:bg-primary-100" aria-label={`Remove ${row.full_name}`}>
                <X className="h-3 w-3" />
              </button>
            </li>
          ))}
        </ul>
      )}
      <SearchPick
        items={staff.filter((row) => !value.includes(row.id))}
        value={adding}
        onChange={(next) => {
          setAdding("");
          if (next) onChange([...value, Number(next)]);
        }}
        label={(row) => row.full_name}
        detail={(row) => humanise(row.role)}
        placeholder="Search staff to add"
        empty="No one matches"
      />
    </div>
  );
}
